import React, { useEffect, useState } from "react";
import Deleteicon from "../../assets/icons/popup/Warning Icon.svg?react";

export default function ConfirmationPopup({ isOpen, onClose }) {
  const [isVisible, setIsVisible] = useState(isOpen);
  const [isAnimating, setIsAnimating] = useState(false);

  // Manage smooth open and close animations
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10); // Small delay to trigger transition
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300); // Wait for animation to finish
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50   transition-opacity duration-300 ${
          isAnimating ? "opacity-100" : "opacity-0"
        }`}
      >
        <div
          className={`w-full max-w-sm bg-white rounded-md px-12 py-5  text-center   transform transition-all duration-300  ease-in-out ${
            isAnimating ? "scale-100 opacity-100" : "scale-95 opacity-0"
          }`}
        >
          {/* Warning Icon */}
          <div className="mb-2.5 inline-flex">
            <div className="w-16 h-16 rounded-full flex items-center justify-center">
              <Deleteicon 
                className=" object-cover "
              />
            </div>
          </div>

          {/* Message */}
          <h3 className="text-base font-normal text-gray-900 mb-2.5">
            Are you sure you want to delete this number?
          </h3>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 text-sm bg-[#0E64D1] text-white rounded-md hover:bg-blue-600 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 text-sm font-semibold bg-[#EF4343] text-white rounded-md hover:bg-red-600 transition-colors"
            >
              Yes, delete it!
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
